
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export type BadgeType = "gold" | "silver" | "bronze";

interface UserBadgeProps {
  type: BadgeType;
  label: string;
  description?: string;
}

export const UserBadge: React.FC<UserBadgeProps> = ({ 
  type, 
  label,
  description 
}) => {
  const badgeStyles = {
    gold: "bg-yellow-500 hover:bg-yellow-600 text-white",
    silver: "bg-gray-400 hover:bg-gray-500 text-white",
    bronze: "bg-amber-700 hover:bg-amber-800 text-white"
  };
  
  const badgeIcons = {
    gold: "🏆",
    silver: "🥈",
    bronze: "🥉"
  };
  
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge className={`${badgeStyles[type]} cursor-help`}>
            {badgeIcons[type]} {label}
          </Badge>
        </TooltipTrigger>
        {description && (
          <TooltipContent side="top" className="z-50 bg-white shadow-md">
            <p>{description}</p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
};

export default UserBadge;
